module.exports = __webpack_public_path__ + "1a19ee5e353e63ee1210636df84b6e80.png";